import React from 'react'
import { Link } from 'react-router-dom';
import { DEFAULT_IMAGE_140 } from '../../middleware/types'

const CategoryContent = ({ containerObject }) => {


  function replaceImage(event) {
    event.target.src = DEFAULT_IMAGE_140;
  }

  return (
    <div className='row targeterCategory'>
      {containerObject && containerObject.targeterResult ? containerObject.targeterResult.map((oneContent) => {
        return (<>
          <div className='col-md-3 col-6'>
            <Link className='c-category-list' to={oneContent && oneContent.url ? oneContent.url : ""}>
              <img onError={replaceImage} alt={oneContent && oneContent.shortName ? oneContent.shortName : ""} src={oneContent && oneContent.categoryImgUrl ? oneContent.categoryImgUrl : ""} />
              <p className='c-category-title'>{oneContent && oneContent.shortName ? oneContent.shortName : ""}</p>
            </Link>
          </div>

        </>)
      })
        : ""}

    </div>
  )
}

export default CategoryContent